// @flow
import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';

import type {Node} from 'react';

type Props = {
    listing: {
        sleeps: number,
        bedrooms: number,
        spaces: {
            spacesSummary: {
                area?: {areaValue?: number},
                bedCountDisplay?: string
            }
        }
    }
};

const RoomsBedsDetails = ({listing}: Props) => {
    const {sleeps, bedrooms, spaces} = listing;
    const {bedCountDisplay} = spaces.spacesSummary;
    const hasBedroomsOrSleepsOrBeds = bedrooms || sleeps || bedCountDisplay;

    return (
        <Fragment>
            {!!hasBedroomsOrSleepsOrBeds && (
                <div className="HitExperimentInfo__room-beds-details">
                    {!!sleeps && (
                        <span>
                            <FormattedMessage
                                id="sleepsAbbreviation"
                                description="sleeps label"
                                defaultMessage="Sleeps {value}"
                                values={{
                                    value: sleeps
                                }}
                            >
                                {(txt: Node): Node => txt}
                            </FormattedMessage>
                        </span>
                    )}
                    {!!bedrooms && (
                        <span>
                            <FormattedMessage
                                id="sectionTitleBedrooms"
                                description="bedrooms label"
                                defaultMessage="bedrooms"
                                values={{
                                    bedrooms
                                }}
                            >
                                {(txt: Node): Node => txt}
                            </FormattedMessage>
                        </span>
                    )}
                    {!!bedCountDisplay && <span>{bedCountDisplay}</span>}
                </div>
            )}
        </Fragment>
    );
};

export default RoomsBedsDetails;
